<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>任务</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openTaskDialog(true, null)"
          >新增任务</el-button
        >
      </div>
      <el-table
        :data="data.tasks"
        border
        size="small"
        style="width: 481px; margin-top: 10px"
      >
        <el-table-column
          prop="id"
          label="编号"
          align="center"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="任务"
          align="center"
          width="300"
        >
          <template slot-scope="scope">
            {{ taskEntries[scope.row.taskId] }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="removeTask(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openTaskDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>商店</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openShopDialog(true, null)"
          >新增支付项</el-button
        >
      </div>
      <el-table
        :data="data.shop"
        border
        size="small"
        style="width: 531px; margin-top: 10px"
      >
        <el-table-column
          prop="id"
          label="编号"
          align="center"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="支付项"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            {{ attachments[scope.row.payShopId] }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="removeShop(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openShopDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>进度阶段宝箱</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openBoxDialog(true, null)"
          >新增宝箱</el-button
        >
      </div>
      <el-table
        :data="data.boxes"
        border
        size="small"
        style="width: 611px; margin-top: 10px"
      >
        <el-table-column
          prop="stage"
          label="阶段"
          align="center"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.stage }}
          </template>
        </el-table-column>
        <el-table-column
          prop="condition"
          label="进度"
          align="center"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.condition }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="奖励"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="removeBox(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openBoxDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>礼包</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openGiftDialog(true, null)"
          >新增礼包</el-button
        >
      </div>
      <el-table
        :data="data.gifts"
        border
        size="small"
        style="width: 971px; margin-top: 10px"
      >
        <el-table-column
          prop="stage"
          label="阶段"
          align="center"
          width="60"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.stage }}
          </template>
        </el-table-column>
        <el-table-column
          prop="condition"
          label="购买所需道具"
          align="center"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ attachments[scope.row.condition] }} x {{ scope.row.consume }}
          </template>
        </el-table-column>

        <el-table-column
          prop="receiveTimes"
          label="可购买次数"
          align="center"
          width="60"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.receiveTimes }}
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="奖励"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="礼包描述"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-popover placement="top" width="400" trigger="hover">
              <el-descriptions :column="1" border>
                <el-descriptions-item
                  :labelStyle="{ width: '55px' }"
                  v-for="(value, language, index) in scope.row.name"
                  :key="index"
                  :label="language"
                  >{{ value }}</el-descriptions-item
                >
              </el-descriptions>
              <div slot="reference" style="white-space: nowrap">
                <div
                  v-for="(value, language, index) in scope.row.name"
                  :key="index"
                  style="text-align: left"
                >
                  {{ language }}：{{ value }}
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="removeGift(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openGiftDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
const axios = require("axios");
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: {
        tasks: [],
        shop: [],
        boxes: [],
        gifts: [],
      },
      rewardsItemResult: {},

      tasks: [],
      taskEntries: {},
      attachments: {},
    };
  },
  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    this.attachments = await this.$bizutil.loadAttachments(true);
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryParamForTaskActivity`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let tasks = resData.data.tasks || [];
      this.tasks = tasks;
      for (let task of tasks) {
        this.taskEntries[task.id] = task.label;
      }
    },
    async openTaskDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditTaskActivityTaskDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.tasks.push(param);
            } else {
              this.$set(that.data.tasks, index, param);
            }

            this.data.tasks.sort((x, y) => {
              return x.id - y.id;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async removeTask(index) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除ID为${this.data.tasks[index].id}的任务？`);
        this.data.tasks.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async openShopDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditTaskActivityShopDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.shop.push(param);
            } else {
              this.$set(that.data.shop, index, param);
            }

            this.data.shop.sort((x, y) => {
              return x.id - y.id;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async removeShop(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除支付项：${
            this.attachments[this.data.shop[index].payShopId]
          }？`
        );
        this.data.shop.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },
    async openBoxDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditTaskActivityBoxDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.boxes.push(param);
            } else {
              this.$set(that.data.boxes, index, param);
            }
            this.data.boxes.sort((x, y) => {
              return x.stage - y.stage;
            });
            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async removeBox(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除阶段${this.data.boxes[index].stage}的宝箱？`
        );
        this.data.boxes.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async openGiftDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditTaskActivityGiftDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.gifts.push(param);
            } else {
              this.$set(that.data.gifts, index, param);
            }
            this.data.gifts.sort((x, y) => {
              return x.stage - y.stage;
            });
            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async removeGift(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除阶段${this.data.gifts[index].stage}的礼包？`
        );
        this.data.gifts.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },
    async updatedItemSelector(param) {
      this.rewardsItemResult = param;
      if (!this.rewardsItemResult.errMsg) {
        this.data.reward = JSON.parse(JSON.stringify(this.rewardsItemResult));
        await this.updatedParam();
      }
    },
    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>